import React, { Component } from "react"
import { QrReader } from "react-qr-reader"
import { Button, Modal } from "react-bootstrap"
import stateMutator from "../StateMutator"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import CameraLense from "./CameraLense/CameraLense"
import CameraNotFound from "./CameraNotFound/CameraNotFound"
import paletteEngine from "../paletteEngine"
//@ts-ignore
import uuid from "react-uuid"
import "./QRScanner.css"

interface Props {
    manageParentState: Function
    handleChange: Function
    closeOnCapture?: boolean
    palette: Array<DynamicFormPaletteTypes>
}

interface State {
    scannerId: string | null
    lenseId: string | null
    cameraOpen: boolean
    noCamera: boolean
}

class QRScanner extends Component<Props, State> {

    state = {
        scannerId: null,
        lenseId: null,
        cameraOpen: false,
        noCamera: false
    }

    componentDidMount() {
        this.manageState([{ key: "scannerId", value: uuid() }, { key: "lenseId", value: uuid() }])
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    /* Removing the lense from the camera. */
    removeLense = () => {
        //@ts-ignore
        let lense = document.getElementById(this.state.lenseId)
        if (lense) {
            lense.classList.add("CameraLenseExit")
            setTimeout(() => {
                //@ts-ignore
                lense.style.display = "none"
            }, 1000)
        }
    }

    /* Checking if the camera is not found and ignoring other errs. */
    handleErr = (err: Error) => {
        if (err.toString().includes("Requested device not found") && !this.state.noCamera) {
            this.manageState([{ key: "noCamera", value: true }])
        }
        // console.log("QRScanner err", err)
    }

    render() {

        const state = this.state
        const props = this.props
        const cameraIsOpen = state.cameraOpen && state.scannerId

        return (
            <div className="QRScanner">
                {cameraIsOpen && < Modal
                    id="qr-scanner-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Body>
                        <div className="QRScannerModalBody">
                            {!state.noCamera && <div className="QRScannerModalBodyHasCamera">
                                <QrReader
                                    onResult={(result, err) => {
                                        if (result) {
                                            props.handleChange(result)
                                            setTimeout(() => {
                                                if (this.props.closeOnCapture) {
                                                    this.manageState([{ key: "cameraOpen" }])
                                                }
                                            }, 500)
                                        }
                                        if (err) {
                                            this.handleErr(err)
                                        }
                                        this.removeLense()
                                    }}
                                    //@ts-ignore
                                    videoId={state.scannerId}
                                    //@ts-ignore
                                    style={{}}
                                />
                            </div>}
                            {!state.noCamera && <CameraLense
                                //@ts-ignore
                                id={state.lenseId}
                            />}
                            {state.noCamera && <div className="QRScannerModalBodyNoCamera">
                                {state.noCamera && <CameraNotFound />}
                            </div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="QRScannerModalFooter">
                            <Button variant="secondary" onClick={() => this.manageState([{ key: "cameraOpen" }])}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
                {!state.cameraOpen && <div className="QRScannerToggleCamera" onClick={() => this.manageState([{ key: "cameraOpen" }])}>
                    <span className="material-icons QRScannerToggleCameraIcon" style={{ color: `${paletteEngine.getPaletteColor( "scannerQRIconColor")}` }}>qr_code_scanner</span>
                </div>
                }
            </div >
        )
    }
}

export default QRScanner